import React from 'react';
import { Box, Button, Divider, Grid, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Form } from 'formik';
import FormikTextField from './FormikTextField';

interface ChangePasswordFormProp {
  onCancel: () => void;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProp> = (prop) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showRetypeNewPassword, setShowRetypeNewPassword] =
    React.useState(false);

  const onShowOldPassword = () => {
    setShowPassword(!showPassword);
  };

  const onDownOldPassword = (event: any) => {
    event.preventDefault();
  };

  const onShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const onDownNewPassword = (event: any) => {
    event.preventDefault();
  };

  const onShowRetypeNewPassword = () => {
    setShowRetypeNewPassword(!showRetypeNewPassword);
  };

  const onDownRetypeNewPassword = (event: any) => {
    event.preventDefault();
  };

  return (
    <Form autoComplete="off">
      <Box>
        <Grid container spacing={4} sx={{ px: 6, pt: 4 }}>
          <Grid item xs={12} md={6}>
            <FormikTextField
              type={showPassword ? 'text' : 'password'}
              name="oldPassword"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={onShowOldPassword}
                      onMouseDown={onDownOldPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              label="Old Password"
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ p: '0 !important' }} />
          <Grid item xs={12} md={6}>
            <FormikTextField
              type={showNewPassword ? 'text' : 'password'}
              name="newPassword"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={onShowNewPassword}
                      onMouseDown={onDownNewPassword}
                      edge="end"
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              label="New Password"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormikTextField
              type={showRetypeNewPassword ? 'text' : 'password'}
              name="retypeNewPassword"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={onShowRetypeNewPassword}
                      onMouseDown={onDownRetypeNewPassword}
                      edge="end"
                    >
                      {showRetypeNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              label="Retype New Password"
            />
          </Grid>
        </Grid>

        <Divider sx={{ mt: 4 }} />

        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              sx={{
                position: 'relative',
                minWidth: 100,
                my: 4,
              }}
              color="primary"
              variant="contained"
              type="submit"
            >
              Save
            </Button>
            <Button
              sx={{
                position: 'relative',
                minWidth: 100,
                my: 4,
                mx: 2
              }}
              color="primary"
              variant="outlined"
              onClick={() => prop.onCancel()}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Form >
  );
};

export default ChangePasswordForm;
